import { render, staticRenderFns } from "./EditNoteDrawer.vue?vue&type=template&id=a5045776"
import script from "./EditNoteDrawer.vue?vue&type=script&lang=js"
export * from "./EditNoteDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports